<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店管理</el-breadcrumb-item>
      <el-breadcrumb-item>退款联系管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-select
            v-model="queryInfo.storeId"
            placeholder="请选择门店"
            clearable
            filterable
            @clear="getList()"
            @change="getList()"
            style="width: 300px;"
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-plus"
            style="margin-left: 10px"
            @click="openDialog()"
            v-permission="'btn:store:refundlink:add'"
          >新增</el-button>
        </el-col>
      </el-row>
      <br>
      <el-table :data="list" style="width: 100%" stripe size="middle" height="700" v-loading="loading">
        <el-table-column label="门店名称" prop="storeName" show-overflow-tooltip></el-table-column>
        <el-table-column label="是否直接退款" prop="isDirectRefundText" width="150"></el-table-column>
        <el-table-column label="退款联系人" prop="refundLink" show-overflow-tooltip></el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        <el-table-column label="最后修改时间" prop="updateTime" width="175"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="openDialog(scope.row)"
              v-permission="'btn:store:refundlink:edit'"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delInfo(scope.row.id)"
              v-permission="'btn:store:refundlink:delete'"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <div align="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="dialogClosed">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="140px">
        <el-form-item label="门店" prop="storeId">
          <el-select
            v-model="form.storeId"
            placeholder="请选择门店"
            filterable
            style="width: 100%"
            :disabled="!!form.id"
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否直接退款" prop="isDirectRefund">
          <el-radio-group v-model="form.isDirectRefund" @change="onDirectRefundChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款联系人" prop="refundLink">
          <el-input v-model="form.refundLink" placeholder="请输入退款联系人" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
            maxlength="500"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'StoreRefundLink',
  data() {
    const validateRefundLink = (rule, value, callback) => {
      if (this.form.isDirectRefund === 0 && !value) {
        callback(new Error('当选择不可直接退款时，退款联系人不能为空'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      btnLoading: false,
      list: [],
      total: 0,
      storelist: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10,
        storeId: null
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        storeId: null,
        isDirectRefund: 0,
        refundLink: '',
        remark: ''
      },
      formRules: {
        storeId: [{ required: true, message: '请选择门店', trigger: 'change' }],
        isDirectRefund: [{ required: true, message: '请选择是否直接退款', trigger: 'change' }],
        refundLink: [{ validator: validateRefundLink, trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
    this.getStoreList()
  },
  methods: {
    async getStoreList() {
      const { data: res } = await this.$http.get('store/')
      this.storelist = res.data || []
    },
    async getList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('storerefundlinklist', { params: this.queryInfo })
        if (res.code === 0 || res.status === 0) {
          this.total = res.totalSize || 0
          this.list = res.data || []
        }
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getList()
    },
    onDirectRefundChange() {
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate('refundLink')
        }
      })
    },
    openDialog(row) {
      if (row) {
        this.dialogTitle = '修改退款联系'
        this.form = {
          id: row.id,
          storeId: row.storeId,
          isDirectRefund: row.isDirectRefund,
          refundLink: row.refundLink || '',
          remark: row.remark || ''
        }
      } else {
        this.dialogTitle = '新增退款联系'
        this.form = {
          id: null,
          storeId: null,
          isDirectRefund: 0,
          refundLink: '',
          remark: ''
        }
      }
      this.dialogVisible = true
    },
    dialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    async delInfo(id) {
      const confirmResult = await this.$confirm('是否确认删除该退款联系记录？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') return
      const { data: res } = await this.$http.get('storerefundlinkdel/' + id)
      if (res.code === 0) {
        this.$message.success('删除成功')
        this.getList()
      } else {
        this.$message.error(res.msg || '删除失败')
      }
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.btnLoading = true
        try {
          const url = this.form.id ? 'storerefundlinkedit' : 'storerefundlinkadd'
          const { data: res } = await this.$http.post(url, this.form)
          if (res.code === 0) {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.msg || '操作失败')
          }
        } finally {
          this.btnLoading = false
        }
      })
    }
  }
}
</script>
